import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-projectdata-table-component',
  templateUrl: './projectdata-table-component.component.html',
  styleUrls: ['./projectdata-table-component.component.css'],
})
export class ProjectdataTableComponentComponent implements OnInit {
  constructor() {}

  // THIS COMPONENT IS CHILD COMPONENT OF PROJECT-DATA TO SHOW TABLE OF RESIDENTS & STAFF SECTION, BECAUSE WE NEED THIS FOR PRINTING ALSO TO SHOW 2 YEARS RECORDS
  hid = 'h1';

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() array: number[] = [];

  @Input() array2: number[] = [];

  @Input() labelsArray: number[] = [];

  @Input() months: number[] = [];

  @Input() start_up_month: number;

  @Output() updateMonth: EventEmitter<any> = new EventEmitter();

  @Output() changeBeds: EventEmitter<any> = new EventEmitter();

  ngOnInit() {}

  // THESE ARE EMITTERS THAT EMIT EVENT TO PARENT WHEN UPDATE STARTUP MONTH AND CHANGE OCCUPIED BEDS INTO INPUT FIELDS
  updateStartUpMonth(month: number) {
    this.updateMonth.emit(month);
  }

  changeBedOccupy(event: any, month: number) {
    this.changeBeds.emit({ event, month });
  }
}



// WEBPACK FOOTER //
// ./src/app/projectdata-table-component/projectdata-table-component.component.ts